// extracted by mini-css-extract-plugin
module.exports = {"item":"MessengerItemChannel_item__3rksU","channel":"MessengerItemChannel_channel__MSlGu"};